import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { createChat } from "./actions";
import type { ChatCompletionState } from "./types";

export function createChatReducerBuilder(
  builder: ActionReducerMapBuilder<ChatCompletionState>
) {
  builder.addCase(createChat.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(createChat.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.messages = action.payload;
    state.isMessageLoading = false;
  });
  builder.addCase(createChat.rejected, (state) => {
    state.isMessageLoading = false;
  });
}
